<template>
  <section class="process">
    <base-container>
      <h2 class="process-title">只要 4 步驟，買遍全世界</h2>
      <div class="process-list">
        <el-row justify="space-between">
          <el-col :sm="24" :lg="5" class="w3-center">
            <img
              src="../../assets/img-process1@2x.jpg"
              class="process-img"
              alt=""
            />
            <div class="round">1</div>
            <p class="process-header-text">註冊會員</p>
            <p>
              註冊成為會員後即可獲得易到家海外倉庫地址，讓你立即到海外網站購物！
            </p>
          </el-col>
          <el-col :sm="24" :lg="5" class="w3-center">
            <img
              src="../../assets/img-process2@2x.jpg"
              class="process-img"
              alt=""
            />
            <div class="round">2</div>
            <p class="process-header-text">註冊會員</p>
            <p>
              註冊成為會員後即可獲得易到家海外倉庫地址，讓你立即到海外網站購物！
            </p>
          </el-col>
          <el-col :sm="24" :lg="5" class="w3-center">
            <img
              src="../../assets/img-process3@2x.jpg"
              class="process-img"
              alt=""
            />
            <div class="round">3</div>
            <p class="process-header-text">註冊會員</p>
            <p>
              註冊成為會員後即可獲得易到家海外倉庫地址，讓你立即到海外網站購物！
            </p>
          </el-col>
          <el-col :sm="24" :lg="5" class="w3-center">
            <img
              src="../../assets/img-process4@2x.jpg"
              class="process-img"
              alt=""
            />
            <div class="round">4</div>
            <p class="process-header-text">註冊會員</p>
            <p>
              註冊成為會員後即可獲得易到家海外倉庫地址，讓你立即到海外網站購物！
            </p>
          </el-col>
        </el-row>
      </div>
    </base-container>
  </section>
</template>

<style scoped>
.process {
  /* margin-bottom: 2rem; */
  background-color: #fff;
  padding: 3rem 0;
  min-width: 990px;
}

.process-title {
  /* padding-top: 3rem 0; */
  text-align: center;
  color: #7a3d87;
  font-size: 28px;
  font-weight: 700;
}

.process-header-text {
  margin-bottom: 1rem;
  color: #7a3d87;
}

.process-img {
  width: 200px;
  margin-bottom: 1rem;
  font-size: 20px;
  font-weight: 500;
}

.round {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: #7a3d87;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0 auto;
  margin-bottom: 1rem;
  box-shadow: 0px 0px 0px 4px rgba(122, 61, 135, 0.2);
  /* border: 2px solid #eedff2; */
  /* padding: 4rem; */
  /* box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2); */
}
</style>